import { render, staticRenderFns } from "./Phd.vue?vue&type=template&id=1e5dec55&scoped=true&"
import script from "./Phd.vue?vue&type=script&lang=js&"
export * from "./Phd.vue?vue&type=script&lang=js&"
import style0 from "./Phd.vue?vue&type=style&index=0&id=1e5dec55&prod&lang=css&"
import style1 from "./Phd.vue?vue&type=style&index=1&id=1e5dec55&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5dec55",
  null
  
)

export default component.exports